<template lang="pug">
.res-detail-card
  .card
    ticket-card
  .info
    .dates
      .date {{year}}年{{month}}月{{date}}日
      time-range(:fs1="30" :fs2="90" :schedule="schedule")
    .fam
      //fam-stack
      avatar-stack(:avatars="avatars")
      .copy {{avatars.length}}位参观者
    .detail
      .row
        .key 门票类型
        .value {{ticketType}}
      .row
        .key 参观人员
        .value {{users}}
      .row
        .key 金额支付
        .value {{moneyDetail}}
      .row
        .key 积分支付
        .value {{pointDetail}}
      .row
        .key 展厅地址
        .value
          p 上海市浦东新区南泉北路447号
          p 支付宝大厦·S空间一层，Alipay Lab
    //.point
      point-deduct
    .total
      .row
        .key 合计
        .value {{total}}
    

  
</template>
<script>
import TicketCard from '@/components/wedgits/TicketCard'
import TimeRange from '@/components/wedgits/TimeRange'
import FamStack from '@/components/wedgits/FamStack'
import PointDeduct from '@/components/res/PointDeduct'
import { mapState, mapGetters } from 'vuex'
import AvatarStack from '@/components/wedgits/AvatarStack'
export default {
  name: 'ResDetailCard',
  components: { AvatarStack, PointDeduct, FamStack, TimeRange, TicketCard },
  props: {
    res: {},
  },
  data() {
    return {
      adultCnt: 0,
      childCnt: 0,
      money: 0,
      point: 0,
      schedule: null,
      ticketType: '',
      tpoint: 0,
      tmoney: 0,
    }
  },
  watch: {
    res(val) {
      this.genInfo(val)
    },
  },
  computed: {
    ...mapState('app', ['schedulePicked', 'user', 'ticketPicked']),
    year() {
      if (!this.schedule) return ''
      return this.schedule.from.getFullYear()
    },
    month() {
      if (!this.schedule) return ''
      return this.schedule.from.getMonth() + 1
    },
    date() {
      if (!this.schedule) return ''
      return this.schedule.from.getDate()
    },
    avatars() {
      // return this.fams.map((u) => {
      //   return u.avatar
      // })
      if (!this.res) return ''
      return this.res.users.map((u) => {
        return u.avatar
      })
    },
    users() {
      return this.childCnt > 0
        ? `${this.adultCnt}成人, ${this.childCnt}儿童`
        : `${this.adultCnt}成人`
    },
    moneyDetail() {
      return this.childCnt > 0
        ? `￥${this.tmoney}X${this.adultCnt}+￥${this.tmoney / 2}X${
            this.childCnt
          }`
        : `￥${this.tmoney}X${this.adultCnt}`
    },
    pointDetail() {
      return this.childCnt > 0
        ? `${this.tpoint}积分X${this.adultCnt}+${this.tpoint / 2}积分X${
            this.childCnt
          }`
        : `${this.tpoint}积分X${this.adultCnt}`
    },
    total() {
      return this.money > 0
        ? `￥${this.money}+${this.point}积分`
        : `${this.point}积分`
    },
  },
  created() {
    //this.genInfo()
  },
  methods: {
    genInfo(res) {
      this.adultCnt = 0
      this.childCnt = 0
      res.users.map((u) => {
        if (u.userType === 0) {
          this.adultCnt++
        } else {
          this.childCnt++
        }
      })
      console.log(this.childCnt)
      let t = JSON.parse(res.ticket)
      let body = ['儿童半价']
      if (t.access === 'all') {
        body.push('包含所有展项')
      } else {
        body.push('不包含以下展项体验：飞跃蚂蚁森林/DAMO 5G赛车漂移/互动区')
      }
      let grade = null
      if (t.grade !== 'all') {
        grade = t.grade
      }
      // this.$set(this.ticket, 'id', t.ticketId)
      // this.$set(this.ticket, 'title', t.ticketName)
      // this.$set(this.ticket, 'point', t.ticketPoint)
      // this.$set(this.ticket, 'money', t.ticketMoney)
      // this.$set(this.ticket, 'body', body)
      // this.$set(this.ticket, 'grade', grade)
      this.ticket = {
        id: t.ticketId,
        title: t.ticketName,
        point: t.ticketPoint,
        money: t.ticketMoney,
        body: body,
        grade: grade,
      }
      this.tpoint = this.ticket.point
      this.tmoney = this.ticket.money
      this.ticketType = this.ticket.title
      this.money =
        this.ticket.money * this.adultCnt +
        (this.ticket.money * this.childCnt) / 2
      this.point =
        this.ticket.point * this.adultCnt +
        (this.ticket.point * this.childCnt) / 2

      this.schedule = this.parseSchedule(res.scheduleId)
      console.log('!!!!!!!!!!!!!!!', this.ticket)
    },
    parseSchedule(s) {
      let strs = s.split('-')
      let from = new Date(Number.parseInt(strs[0]))
      let to = new Date(Number.parseInt(strs[1]))
      let quota = null
      let status = null
      return {
        from: from,
        to: to,
        id: s,
        quota: quota,
        status: status,
      }
    },
  },
  mounted() {
    //this.genInfo()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-detail-card
  +full
  position: relative
  width: 100%
  height: 100%
  .card
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
  .info
    position: relative
    z-index: 10
    width: 100%
    height: 100%
    padding: pxToRem(38) pxToRem(80)
    .dates
      animation: fadeIn 0.7s $easeOutCubic both 0.2s
      .date
        font-size: pxToRem(36)
        font-family: $ff-cn
        line-height: pxToRem(50)
        letter-spacing: pxToRem(0.8)
    .fam
      animation: fadeIn 0.7s $easeOutCubic both 0.4s
      margin-top: pxToRem(90)
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      flex-direction: row
      .copy
        font-size: pxToRem(26)
        color: black
    .detail
      margin-top: pxToRem(50)
      width: 100%
      .row
        width: 100%
        display: flex
        align-items: flex-start
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(26)
        margin-bottom: pxToRem(15)
        .value
          text-align: right
    .total
      animation: fadeIn 0.7s $easeOutCubic both 0.6s
      margin-top: pxToRem(60)
      .row
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        font-size: pxToRem(32)
        .value
          color: $cl-orange
@keyframes fadeIn
  0%
    opacity: 0
    transform: translateY(20%)
  100%
    opacity: 1
    transform: translateY(0)
</style>
